import React, { useEffect, useState } from 'react';
import axios from 'axios';

function AdminDeposits() {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('https://api.herracim.az/api/dashboard/depositStats', { withCredentials: true })
      .then(res => setStats(res.data || {}))
      .catch(err => console.error('Xəta:', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p>Yüklənir...</p>;

  const formatAmount = (value) => {
    if (typeof value === 'number') return `${value.toFixed(2)} AZN`;
    return '0.00 AZN';
  };

  return (
    <div className="admin-deposits">
      <h2>💰 Depozit Statistikaları</h2>
      <div className="deposit-grid">
        <div className="stat-box">
          <h4>Ümumi Depozit</h4>
          <p>{formatAmount(stats.totalDeposit)}</p>
        </div>
        <div className="stat-box">
          <h4>Platforma Gəliri (1%)</h4>
          <p>{formatAmount(stats.platformIncome)}</p>
        </div>
        <div className="stat-box">
          <h4>Satıcılara Ödəniş</h4>
          <p>{formatAmount(stats.totalSentToSellers)}</p>
        </div>
        <div className="stat-box">
          <h4>Geri Qaytarılan Depozit</h4>
          <p>{formatAmount(stats.refundedDeposit)}</p>
        </div>
        <div className="stat-box">
          <h4>Təsdiqlənmiş Depozit Sayı</h4>
          <p>{stats.confirmedCount ?? 0}</p>
        </div>
        <div className="stat-box">
          <h4>Şikayətlər</h4>
          <p>{stats.reportCount ?? 0}</p>
        </div>
      </div>
    </div>
  );
}

export default AdminDeposits;
